
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 43 43","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.64 31.989l-6.699-3.876a10.724 10.724 0 01-8.45 4.122c-3.299 0-6.415-1.52-8.448-4.122L6.345 31.99l-2.673 1.538a23.068 23.068 0 002.61 3.168 21.5 21.5 0 0030.419 0 23.074 23.074 0 002.611-3.168l-2.673-1.538zm.06-25.745h.001A21.33 21.33 0 0023.028 0v10.888a10.7 10.7 0 016.573 3.59 10.719 10.719 0 012.614 7.022 11.188 11.188 0 01-.737 3.937l6.698 3.906 2.642 1.538A21.036 21.036 0 0043 21.47a21.45 21.45 0 00-6.3-15.226zm-30.417 0a21.573 21.573 0 00-4.117 24.637l2.642-1.538 6.698-3.906a11.188 11.188 0 01-.737-3.937 10.72 10.72 0 012.614-7.023 10.7 10.7 0 016.573-3.589V0A21.329 21.329 0 006.283 6.244z","fill":"currentColor"}})])
          )
        }
      }
    